import { useState } from "react"
import ErrorMessage from "@/v2-ui/ErrorMessage"
import Dialog from "@/v2-ui/dialog"
import Button, { TooltipButton } from "@/v2-backoffice-client/components/button"
import { useUserDeleteMfaPhoneMutation } from "@/v2-backoffice-client/user/mfa/user.mfa.deletePhone.mutation"

export type UserMfaDeletePhoneProps = {
  userId: number
  methodId: string
  phoneNumber: string
  onCompleted?(): void
}

// Removes a single registered phone method (targeted alternative to the
// "Reset MFA" action, which clears every method at once).
function UserMfaDeletePhone(props: UserMfaDeletePhoneProps) {
  const { userId, methodId, phoneNumber, onCompleted } = props

  const [open, setOpen] = useState(false)

  const [deletePhone, { loading, error }] = useUserDeleteMfaPhoneMutation({
    onCompleted() {
      setOpen(false)
      onCompleted?.()
    },
  })

  return (
    <>
      <TooltipButton
        variant="destructive"
        size="sm"
        content="Remove this phone as an MFA method. A targeted alternative to Reset MFA, which clears every method."
        onClick={() => {
          setOpen(true)
        }}
        iconSrc="trash"
      >
        Delete
      </TooltipButton>

      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>Delete phone method</Dialog.Title>
            <Dialog.Description>
              Remove {phoneNumber} as an MFA method? The user will need to
              register a new method on their next sign-in.
            </Dialog.Description>
          </Dialog.Header>

          <ErrorMessage className="my-2 text-center" error={error} />

          <Dialog.Footer>
            <Button
              type="button"
              variant="ghost"
              onClick={() => {
                setOpen(false)
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              isLoading={loading}
              onClick={() => {
                deletePhone({ variables: { id: userId, methodId } })
              }}
            >
              Delete
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog>
    </>
  )
}

export default UserMfaDeletePhone
